import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePickerModule, DateTimePickerComponent, DateTimePickerModule } from '@progress/kendo-angular-dateinputs';
import { ReactiveFormsModule } from '@angular/forms';
import { DatePickerControlComponent } from '../date-picker-control/date-picker-control.component';
import { placeholderDateTimeFormat } from '../../../../../../shared/constants/date-time-placeholders';
import { TooltipComponent } from '../../../../../../shared/components/ui/tooltip/tooltip.component';
import { userSettingsFeature } from 'src/app/store/features/user-settings/user-settings-feature';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CollectionFormField } from '../../../../../../../models/ts/collection-form-field.model';
import { getTimezoneOffset, toZonedTime } from 'date-fns-tz';
import { formatISO } from 'date-fns';
/**
 * Represents a control that allows the user to select a date and time.
 */
@Component({
  selector: 'bizz-date-time-picker-control',
  standalone: true,
  imports: [CommonModule, DateTimePickerModule, DatePickerModule, ReactiveFormsModule, TooltipComponent],
  templateUrl: './date-time-picker-control.component.html',
  styleUrls: ['./date-time-picker-control.component.scss']
})
export class DateTimePickerControlComponent extends DatePickerControlComponent{
  protected override placeholderFormat = placeholderDateTimeFormat;

  private timeZoneName = this.store$.selectSignal(
    userSettingsFeature.selectTimezoneName,
  );

  @ViewChild('input') public dateTimeinputElement: DateTimePickerComponent;

  public override ngOnInit(): void {
    super.ngOnInit();
    // TODO: remove once BE passes valid format string
    // if formcontrol has default date then set it to today
    this.dateFormat = this.placeholderFormat;
    this.store$.select(userSettingsFeature.selectDateTimeFormatTypeString).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: value => {
        // TODO: uncomment when BE passes valid format strings
         this.dateFormat = this.dateFilterService.convertDateMomentFormat(value) ?? this.placeholderFormat;
      }
    });
    
  }

  public override ngAfterViewInit(): void{
    super.ngAfterViewInit();
    const objFrame = document.getElementById('TabIDTimePicker'+this.formFieldSignal()?.Bookmark);

    // Set tabindex to 0 or -1 to rendered input component.
    if (objFrame) {
      if (objFrame.firstElementChild){
        objFrame.firstElementChild.removeAttribute('tabindex')
        objFrame.firstElementChild.removeAttribute('ng-reflect-tabindex')
        objFrame.firstElementChild.setAttribute('tabindex', (this.readOnlyOverride || this.formFieldSignal()?.IsReadOnly ? '-1' : '0'))

        if (objFrame.firstElementChild.firstElementChild) {
          objFrame.firstElementChild.firstElementChild.setAttribute('tabindex', (this.readOnlyOverride || this.formFieldSignal()?.IsReadOnly ? '-1' : '0'))
        }

      }
    }
  }

  protected override valueSetter(field: CollectionFormField): void {
    if(field.Value === null){
      this.formControl.setValue(undefined, { emitEvent: false });
    }else{
      this.formControl.setValue(toZonedTime(new Date(field.Value), this.timeZoneName()), { emitEvent: false });
    }
  }

  protected override valueChangeDispatcher(value: any): void {
    if(value !== null){
      super.valueChangeDispatcher(this.dateFilterService.calculateDateWithTimezoneAndDst(this.timeZoneName(), value));
    }else{
      super.valueChangeDispatcher(value);
    }
  }

  public override setCurrentDate(): void {
    if(this.formControl.value === undefined && !(this.formFieldSignal()?.IsReadOnly || this.readOnlyOverride)){
      this.formControl.setValue(toZonedTime(new Date(), this.timeZoneName()));
      this.formControl.markAsDirty();
      this.focus();
    }
  }

  public override hidePopup(): void {
    this.dateTimeinputElement.toggle(false);
   }

   public onPopupOpen(): void {
    //if no value is inside the formControl, set it to now as the datetimepicker will crash otherwise
    if(!this.formControl.value) 
      this.formControl.setValue(toZonedTime(Date.now(), this.timeZoneName()));
   }

  protected override focus(): void {
    this.inputElement.focus();
  }
}
